
<template>
  <div class="DataUpdate">
    <modal
      name="GradeModal"
      width="80%"
      height="auto"
      :scrollable="false"
      :adaptive="true"
      :clickToClose="false"
    >
      <div class="tabcontent">
        <ValidationObserver ref="obsFieldsUpdate">
          <FormupdateGrades
            :FieldsForm="formUpdate"
            :ModelForm="formUpdModel"
            :method="executeProcess"
            v-if="renderComponent2"
          />
        </ValidationObserver>
        <va-notification
          color="danger"
          v-if="refValidator"
          class="refNoData"
        >
          {{ AlertValidator }}
        </va-notification>
        <div class="modalActions">
          <button
            v-if="!isNew"
            id="updatePeriod"
            class="loginbtn primaryBtn"
            @click="updatePeriod"
          >
            Actualizar
          </button>

          <button
            v-else
            id="AddModal"
            class="loginbtn primaryBtn"
            @click="AddModal"
          >
            Guardar
          </button>

          <button
            id="CancelUser"
            class="loginbtn secondaryBtn"
            @click="CancelUser"
          >
            Cancelar
          </button>
        </div>
      </div>
    </modal>
    <div class="titlePage">
      Administración - Grados Ibero
    </div>
    <va-notification color="info" v-if="addRExito" class="refNoData">
      Se creó correctamente el Grado solicitado.
    </va-notification>

    <va-notification color="info" v-if="UpdRExito" class="refNoData">
      Se actualizó correctamente el Grado solicitado.
    </va-notification>

    <va-notification color="danger" v-if="refNoUpdate" class="refNoData">
      La actualización del Grado presentó un fallo.
    </va-notification>

    <va-notification color="danger" v-if="refWSUpdate" class="refNoData">
      El servicio que ejecuta la actualización no se encuentra activo.
    </va-notification>
    <ValidationObserver ref="obsFieldsSearch">
      <FormSearchGrade
        :FieldsForm="formSearch"
        :ModelForm="formSchModel"
        :method="executeProcess"
      />
    </ValidationObserver>
    <va-notification
      color="danger"
      id="refNoData"
      class="refNoData noShow"
    >
      No se encontró información del Grado solicitado.
    </va-notification>
    <div class="listGrades">
      <DataTableGrades
        :InfoView="DLGrades"
        :HeadTable="HDGrades"
        :method="processData"
        v-if="renderComponent1"
      />
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-duplicates
import FormSearchGrade from '@/components/forms/Forms.vue'
import FormupdateGrades from '@/components/forms/Forms.vue'
import IberoHelpers from '@/store/helpers.js'
import DataTableGrades from '@/components/data-tables/DataGrade.vue'
export default {
  name: 'DataUpdate',
  components: {
    DataTableGrades,
    FormSearchGrade,
    FormupdateGrades,
  },
  data () {
    return {
      AlertValidator: '',
      formSchModel: {},
      formSearch: [
        {
          id: 'Sch_Button',
          type: 'button',
          placeholder: 'Consultar Grado',
          class: 'btn-action',
        },
        {
          id: 'Sch_ButtonNew',
          type: 'button',
          placeholder: 'Crear Grado',
          class: 'btn-create',
        },
      ],
      formUpdModel: {
        Id_Grade: 0,
        Period_Grade: '',
        Information: '',
        staActive: '',
        Porcent_Approved: '',
        Date_Grade: '',
        dat_StartInscription: '',
        dat_EndInscription: '',
        existCeremony: '',
      },

      formUpdate: [
        {
          id: 'Period_Grade',
          model: 'Period_Grade',
          name: 'Grado',
          type: 'input',
          placeholder: 'Grado',
          values: '',
          validate: {
            required: true,
            regex: '^([a-zA-z]?)',
            max: 6,
          },
          class: 'col-md-6'
        },
        {
          id: 'Information',
          model: 'Information',
          name: 'Informacion del Grado',
          type: 'input',
          placeholder: 'Informacion del grado',
          class: 'col-md-6',
          values: '',
          validate: {
            required: true,
            regex: '^([a-zA-z]?)',
          },
        },
        {
          id: 'staActive',
          model: 'staActive',
          name: 'Estado',
          type: 'Select',
          placeholder: 'Seleccionar...',
          class: 'col-md-6',
          values: [
            { id: 'true', value: 'Activo' },
            { id: 'false', value: 'Inactivo' },
          ],
          validate: {
            required: true,
          },
        },

        {
          id: 'Date_Grade',
          model: 'Date_Grade',
          name: 'Fecha Grado',
          type: 'datepicker',
          placeholder: 'Fecha Grado',
          dateTimePickerOptions: {
            format: 'yyyy/MM/dd',
            disabledDates: {
            } },
          validate: {
            required: true,
          },
          class: 'col-md-6',
        },
        {
          id: 'dat_StartInscription',
          model: 'dat_StartInscription',
          name: 'Inicio Inscripción',
          type: 'datepicker',
          placeholder: 'Inicio Inscrpción',
          dateTimePickerOptions: {
            format: 'yyyy/MM/dd',
            disabledDates: {
            } },
          validate: {
            required: true,
          },
          class: 'col-md-6',
        },
        {
          id: 'dat_EndInscription',
          model: 'dat_EndInscription',
          name: 'Fin Inscripción',
          type: 'datepicker',
          placeholder: 'Fin Inscripción',
          dateTimePickerOptions: {
            format: 'yyyy/MM/dd',
            disabledDates: {
            } },
          validate: {
            required: true,
          },
          class: 'col-md-6',
        },
        {
          id: 'Percent_Approved',
          model: 'Percent_Approved',
          name: 'Porcentaje Aprobacion',
          type: 'input',
          placeholder: 'Porcentaje Aprobación',
          values: '',
          validate: {
            required: true,
            regex: '^([0-9]?)',
            max: 3,
          },
          class: 'col-md-6',
        },
        {
          id: 'existCeremony',
          model: 'existCeremony',
          name: 'Tiene Ceremonia',
          type: 'Select',
          placeholder: 'Seleccionar...',
          class: 'col-md-6',
          values: [
            { id: 'Si', value: 'Si' },
            { id: 'No', value: 'No' },
          ],
          validate: {
            required: true,
          },
        },
      ],

      HDGrades: [
        {
          name: 'Id_Grade',
          title: 'Id',
          sortField: 'Id_Grade',
          width: '20%',
        },
        {
          name: 'Period_Grade',
          title: 'Grado',
          sortField: 'Period_Grade',
          width: '20%',
        },
        {
          name: 'Percent_Approved',
          title: 'Porcentaje Aprobación',
          sortField: 'Percent_Approved',
          width: '10%',
        },
        {
          name: 'Information',
          title: 'Informacion del Grado',
          sortField: 'Information',
          width: '40%',
        },
        {
          name: 'Date_Grade',
          title: 'fecha grado',
          sortField: 'Date_Grade',
          width: '20%',
        },
        {
          name: '__slot:staActive',
          title: 'Activo',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: 'dat_StartInscription',
          title: 'inicio inscripción',
          sortField: 'dat_StartInscription',
          width: '15%',
        },
        {
          name: 'dat_EndInscription',
          title: 'fin inscripción',
          sortField: 'dat_EndInscription',
          width: '15%',
        },
        {
          name: 'existCeremony',
          title: 'Tiene Ceremonia',
          sortField: 'existCeremony',
          width: '15%',
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
          actionRef: [
            {
              label: 'Editar',
              icon: 'fa-pencil',
              action: 'edit',
            },
          ],
        },
      ],
      DLGrades: [],
      renderComponent1: false,
      renderComponent2: false,
      addRExito: false,
      UpdRExito: false,
      refNoUpdate: false,
      refWSUpdate: false,
      refValidator: false,
      isNew: false,
    }
  },
  methods: {
    executeProcess: function (event, refer) {
      this.limpiaref()
      switch (event.target.id) {
        case 'Percent_Approved':
          if (this.formUpdModel.Percent_Approved > 100) {
            this.AlertValidator = 'El numero no puede ser mayor a 100'
            this.refValidator = true
          }
          break
        case 'btn_Sch_Button':
          this.isNew = false
          return new Promise((resolve, reject) => {
            this.$refs.obsFieldsSearch.validate().then(results => {
              if (!results) {
                resolve(false)
              } else {
                this.searchForm()
                resolve(true)
              }
            })
          })
        case 'btn_Sch_ButtonNew':
          this.limpiaref()
          this.clearFields()
          this.isNew = true
          IberoHelpers.forceRerender2(this)
          this.$modal.show('GradeModal')
      }
      this.$refs.obsFieldsSearch.validate()
    },
    ValidatorDates (date1, date2) {
      if (date2 >= date1) { return true } else { return false }
    },
    searchForm () {
      document.getElementById('refNoData').classList.add('noShow')

      this.isNew = false
      let loader = this.$loading.show()
      var ListGrades = IberoHelpers.getGrade(this.$store, this.formSchModel, 0)
      this.renderComponent1 = false
      ListGrades.then(Response => {
        if ((Response.data === undefined) || (Response.data === '')) {
          document.getElementById('refNoData').classList.remove('noShow')
        } else {
          if (Array.isArray(Response.data)) {
            this.DLGrades = Response.data
          } else {
            this.DLGrades = [Response.data]
          }
          IberoHelpers.forceRerender1(this)
        }
        loader.hide()
      })
    },
    updatePeriod () {
      return new Promise((resolve, reject) => {
        this.limpiaref()
        if (!this.ValidatorDates(this.formUpdModel.dat_StartInscription, this.formUpdModel.dat_EndInscription)) {
          this.AlertValidator = 'La fecha inicial de inscripcion no puede ser mayor a la fecha final'
          this.refValidator = true
          resolve(false)
        } else if (!this.ValidatorDates(this.formUpdModel.dat_StartInscription, this.formUpdModel.Date_Grade)) {
          this.AlertValidator = 'La fecha de inicio de inscripcion no puede ser mayor a la fecha de graduación'
          this.refValidator = true
          resolve(false)
        } else if (!this.ValidatorDates(this.formUpdModel.dat_EndInscription, this.formUpdModel.Date_Grade)) {
          this.AlertValidator = 'La fecha final de inscripcion no puede ser mayor a la fecha de graduación'
          this.refValidator = true
          resolve(false)
        } else if (this.formUpdModel.Percent_Approved > 100) {
          this.AlertValidator = 'El numero de porcentaje aprobado no puede ser mayor a 100'
          this.refValidator = true
          resolve(false)
        } else {
          this.$refs.obsFieldsUpdate.validate().then(results => {
            if (!results) {
              resolve(false)
            } else {
              let loader = this.$loading.show()
              var totalinf = IberoHelpers.UpdateGrade(this.$store, this.formUpdModel, this.$session.get('IberoJWTAdminLogin').idPerson)
              totalinf.then(Response => {
                this.renderComponent1 = false
                if (Response === false) {
                  this.refWSUpdate = true
                  resolve(false)
                } else if (!(Response.status === 200)) {
                  this.refNoUpdate = true
                  resolve(false)
                } else {
                  this.UpdRExito = true
                  this.refValidator = false
                  resolve(true)
                }
                this.$modal.hide('GradeModal')
                this.searchForm()
                loader.hide()
              })
            }
          })
        }
      })
    },
    AddModal () {
      return new Promise((resolve, reject) => {
        this.limpiaref()
        if (!this.ValidatorDates(this.formUpdModel.dat_StartInscription, this.formUpdModel.dat_EndInscription)) {
          this.AlertValidator = 'La fecha inicial de inscripcion no puede ser mayor a la fecha final'
          this.refValidator = true
          resolve(false)
        } else if (!this.ValidatorDates(this.formUpdModel.dat_StartInscription, this.formUpdModel.Date_Grade)) {
          this.AlertValidator = 'La fecha de inicio de inscripcion no puede ser mayor a la fecha de graduación'
          this.refValidator = true
          resolve(false)
        } else if (!this.ValidatorDates(this.formUpdModel.dat_EndInscription, this.formUpdModel.Date_Grade)) {
          this.AlertValidator = 'La fecha final de inscripcion no puede ser mayor a la fecha de graduación'
          this.refValidator = true
          resolve(false)
        } else {
          this.$refs.obsFieldsUpdate.validate().then(results => {
            if (!results) {
              resolve(false)
            } else {
              let loader = this.$loading.show()
              var totalinf = IberoHelpers.AddGrade(this.$store, this.formUpdModel, this.$session.get('IberoJWTAdminLogin').idPerson)
              console.log(this.formUpdModel)
              totalinf.then(Response => {
                this.renderComponent1 = false
                if (Response === false) {
                  this.refWSUpdate = true
                  resolve(false)
                } else if (!(Response.status === 200)) {
                  this.refNoUpdate = true
                  resolve(false)
                } else {
                  this.addRExito = true
                  this.refValidator = false
                  resolve(true)
                }
                this.$modal.hide('GradeModal')
                this.searchForm()
                loader.hide()
              })
            }
          })
        }
      })
    },
    CancelUser () {
      this.limpiaref()
      this.clearFields()
      this.$modal.hide('GradeModal')
    },
    limpiaref () {
      this.addRExito = false
      this.UpdRExito = false
      this.refNoUpdate = false
      this.refWSUpdate = false
      this.refValidator = false
      document.getElementById('refNoData').classList.add('noShow')
    },
    clearFields () {
      this.AlertValidator = ''
      this.formUpdModel.Id_Grade = 0
      this.formUpdModel.Period_Grade = ''
      this.formUpdModel.staActive = ''
      this.formUpdModel.Date_Grade = ''
      this.formUpdModel.Percent_Approved = ''
      this.formUpdModel.Information = ''
      this.formUpdModel.dat_StartInscription = ''
      this.formUpdModel.dat_EndInscription = ''
      this.formUpdModel.existCeremony = ''
    },
    processData: function (dataInf) {
      this.limpiaref()
      this.isNew = false
      debugger
      this.formUpdModel.Id_Grade = dataInf.Id_Grade
      this.formUpdModel.Period_Grade = dataInf.Period_Grade
      this.formUpdModel.Percent_Approved = dataInf.Percent_Approved
      this.formUpdModel.staActive = dataInf.staActive
      this.formUpdModel.Date_Grade = dataInf.Date_Grade + 'T00:00:00.000Z'
      this.formUpdModel.Information = dataInf.Information
      this.formUpdModel.existCeremony = dataInf.existCeremony

      if (dataInf.staActive === 'true') {
        this.formUpdModel.staActive = 'true'
      } else {
        this.formUpdModel.staActive = 'false'
      }
      this.formUpdModel.dat_StartInscription = dataInf.dat_StartInscription + 'T00:00:00.000Z'
      this.formUpdModel.dat_EndInscription = dataInf.dat_EndInscription + 'T00:00:00.000Z'
      IberoHelpers.forceRerender2(this)
      this.$modal.show('GradeModal')
      return ''
    },
  },
}
</script>